<template>
  <div v-loading="isLoading" class="wrapper">
    <div class="title" :class="headType === '2' ? 'girlline' : ''">
      <span
        class="title-content"
        :style="{ color: headType === '2' ? '#c09fcd' : '' }"
        >{{
          watchImg != 0 ? current_info.title_zh_hk : current_info.title_en
        }}</span
      >
    </div>
    <div v-loading="isLoading" class="content">
      <swiper
        :options="swiperOption"
        v-if="current_info.photos.length > 1"
        class="imgUrls"
      >
        <swiper-slide
          v-for="(item, index) in current_info.photos"
          :key="index"
          class="imgUrls-item"
        >
          <img :src="item.temp_path_url" alt="" width="90%" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="img-box" v-else>
        <img :src="current_info.photos[0].temp_path_url" alt="" />
      </div>
      <div class="description-content">
        <div style="font-size:17px;font-weight:500;line-height:32px;">
          {{ watchImg != 0 ? current_info.title_zh_hk : current_info.title_en }}
        </div>
        <div
          class="description"
          v-html="
            watchImg != 0 ? current_info.details_zh_hk : current_info.details_en
          "
        ></div>
      </div>
    </div>
    <div class="end">
      <div
        class="left"
        :class="headType === '2' ? 'girlleft' : ''"
        @click="returnPre"
        v-text="watchImg != 0 ? '返回文章列表' : 'Back to the article list'"
      ></div>
      <div class="right">
        <div
          class="right-button"
          :class="[
              headType === '2' ? 'girlright' : '',
              prev_id === null ? 'disabled' : ''
            ]"
          v-text="watchImg != 0 ? '上一篇' : 'PREV'"
          @click="showPre"
          :disabled="prev_id === null"
        >
          <i class="el-icon-arrow-left icon-l"></i><span></span>
        </div>
        <div
          :class="[
            headType === '2' ? 'girlright' : '',
            next_id === null ? 'disabled' : ''
          ]"
          class="right-button"
          v-text="watchImg != 0 ? '下一篇' : 'NEXT'"
          @click="showNext"
          :disabled="next_id === null"
        >
          <span> </span> <i class="el-icon-arrow-right icon-r"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BasketballApi } from "../../src/api/basketball";
import { mapState } from "vuex";
export default {
  props: {
    info: Object,
    showIndex: Number,
    name: String
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        direction: "horizontal",
        loop: true,
        autoplay: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      number: null,
      watchImg: window.localStorage.getItem("watchImg") || 0,
      current_info: this.info,
      current_id: this.info.id,
      prev_id: this.info.prev_id,
      next_id: this.info.next_id,
      isLoading: false,
      // year: this.info.year
    };
  },
  watch: {
    headType() {
      this.getStories();
    }
  },
  computed: {
    ...mapState(["headType"])
  },
  methods: {
    getStories() {
      this.isLoading = true;
      BasketballApi.getStories("/" + this.current_id)
        .then((res) => {
          this.isLoading = false;
          if (res) {
            this.current_id = res.id;
            this.prev_id = res.prev_id;
            this.next_id = res.next_id;
            this.current_info = res;
          } else {
            this.$message({
              message: this.$i18n.t("message.no_data"),
              type: "warning"
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$message({
            message: this.$i18n.t("message.no_data"),
            type: "warning"
          });
        });
    },
    returnPre() {
      this.$emit("show", false);
      if (this.name == "more") {
        this.$router.push({ path: "/more", query: { type: this.headType } });
      } else {
        this.$router.push({
          path: "/bestteammate",
          query: { type: this.headType }
        });
      }
    },
    showPre() {
      if (this.prev_id == null) {
        this.$message({
          message: this.$i18n.t("message.no_story"),
          type: "warning"
        });
        return;
      }
      
      this.isLoading = true;
      BasketballApi.getStories("/" + this.prev_id)
        .then((res) => {
          this.isLoading = false;
          if (res) {
            this.next_id = this.current_id;
            this.current_id = res.id;
            this.prev_id = res.prev_id;
            this.current_info = res;
            location.hash = this.current_id;
          } else {
            this.$message({
              message: this.$i18n.t("message.no_story"),
              type: "warning"
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$message({
            message: this.$i18n.t("message.no_data"),
            type: "warning"
          });
        });
    },
    showNext() {
      if (this.next_id == null) {
        this.$message({
          message: this.$i18n.t("message.no_story"),
          type: "warning"
        });
        return;
      }
      this.isLoading = true;
      BasketballApi.getStories("/" + this.next_id)
        .then((res) => {
          this.isLoading = false;
          if (res) {
            this.prev_id = this.current_id;
            this.current_id = res.id;
            this.next_id = res.next_id;
            this.current_info = res;
            location.hash = this.current_id;
          } else {
            this.$message({
              message: this.$i18n.t("message.no_story"),
              type: "warning"
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$message({
            message: this.$i18n.t("message.no_data"),
            type: "warning"
          });
        });
    }
  },
  created() {
    this.getStories();
  }
};
</script>
<style lang="scss" scoped>
.right-button {
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
    
    &:hover {
      background: inherit;
      color: inherit;
    }
  }
}
.wrapper {
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  // box-shadow: 1px 1px 1px 1px #888888;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 2% 3%;
    border-bottom: 4px solid #4d8bc4;
    .title-content {
      color: #5e98ca;
      font-size: 16px;
      font-weight: 900;
    }
    .date {
      color: #7c7d7f;
      font-size: 16px;
    }
  }
  .girlline {
    border-bottom: 4px solid #c09fcd;
  }
  .content {
    padding: 2% 3%;
    .imgUrls {
      max-height: 520px;
      .imgUrls-item {
        text-align: center;
        img {
          width: 80%;
        }
      }
    }
    .img-box {
      width: 100%;
      height: 500px;
      margin-right: 4%;
      overflow: hidden;
      text-align: center;
      img {
        width: 50%;
        height: 100%;
        object-fit: cover;
        object-position: top;
      }
      @media screen and (max-width: 780px) {
        height: 250px;
        img {
          width: 100%;
        }
      }
    }
    .description-content {
      margin-top: 2%;
      .description-title {
        font-size: 16px;
        font-weight: 900;
        margin-bottom: 1%;
      }
      .description {
        color: #898a8c;
        line-height: 26px;
      }
    }
  }
  .end {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 2% 3%;
    @media screen and (max-width: 780px) {
      justify-content: flex-start;
      align-items: flex-start;
    }
    .left {
      width: 200px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border: 1px solid #4d8bc4;
      border-radius: 20px;
      color: #4d8bc4;
      cursor: pointer;
      margin-bottom: 2%;
      transition: all 0.6s;
    }
    .left:hover {
      background: #4d8bc4;
      color: #fff;
    }
    .girlleft {
      border: 1px solid #c09fcd;
      color: #c09fcd;
    }
    .girlleft:hover {
      background: #c09fcd;
    }
    .right {
      max-width: 350px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      @media screen and (max-width: 780px) {
        justify-content: flex-start;
      }
      .right-button {
        position: relative;
        width: 150px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border: 1px solid #4d8bc4;
        border-radius: 20px;
        color: #4d8bc4;
        cursor: pointer;
        margin-bottom: 2%;
        transition: all 0.6s;
        .icon-l {
          position: absolute;
          top: 50%;
          left: 8%;
          font-size: 20px;
          transform: translateY(-50%);
        }
        .icon-r {
          position: absolute;
          top: 50%;
          right: 8%;
          font-size: 20px;
          transform: translateY(-50%);
        }
      }
      .girlright {
        border: 1px solid #c09fcd;
        color: #c09fcd;
      }
      .right-button:first-child {
        margin-right: 6%;
      }
      .right-button:hover {
        background: #4d8bc4;
        color: #fff;
      }
      .girlright:hover {
        background: #c09fcd;
      }
    }
  }
}
</style>